import EnumType from "./EnumType.js";

const values =  {
  Gold: 0,
  Silver: 1,
  Copper: 2,
  Zinc: 3,
  Lead: 4,
  Carbon: 5,
  Sulfur: 6
};

export default EnumType.generate(values, "Element.");
